import { fetchDepartureAreas } from 'store/searchAreas/actions';

import { universalRouterProps } from 'core/universalRouter/types';

export default ({ store: { dispatch } }: universalRouterProps) => {
  return Promise.all([dispatch(fetchDepartureAreas())]);
};
